<template>
  <div class="home">
    <b-container fluid>
      <h1 v-if="hasAnyRole()">{{ $keycloak.fullName }}'s Work Queues</h1>
      <h1 v-if="!hasAnyRole()">{{ $keycloak.fullName }}'s dashboard</h1>
    <div v-if="hasAnyRole()">
      <b-spinner class="m-5" variant="primary" label="Loading your dashboard.  Please wait."
        v-if="myWorkQueueLoading || mySubmissionsLoading">Loading your dashboard.  Please wait.</b-spinner>
    </div>

      <div v-if="hasAnyRole()">
        <b-row class="mt-4" v-if="$keycloak.authenticated && isSpecialist()">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">My Assigned Requests</h2>
              <ApprovalQueue slug="assigned-queue"
                             :items="myWorkQueue" :isLoading="myWorkQueueLoading"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4"
               v-if="$keycloak.authenticated && (isPayroll() || isAdmin())">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">My Payroll Assigned Requests</h2>
              <b-form-checkbox v-model="payrollAssignedOnly" name="assigned-input" switch @change="loadPayrollQueue($event)">
                Show My Assigned Requests Only
              </b-form-checkbox>
              <ApprovalQueue slug="payroll-queue"
                             :items="myPayrollQueue" :isLoading="myWorkQueueLoading"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="$keycloak.authenticated && isFfm()">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">FM Reviews</h2>
              <ApprovalQueue slug="fm-review-queue" :items="fmApprovals"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="myApprovals.length > 0">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">My Approvals</h2>
              <ApprovalQueue slug="approval-queue" :items="myApprovals"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="myHiringManagerQueue.length > 0">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">Hiring Manager Requests</h2>
              <ApprovalQueue slug="hiring-manager-queue"
                             :items="myHiringManagerQueue" :isLoading="myWorkQueueLoading"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="mySpecialistQueue.length > 0">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">Assigned Specialist Requests</h2>
              <ApprovalQueue slug="specialist-queue"
                             :items="mySpecialistQueue" :isLoading="myWorkQueueLoading"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="!isSpecialist() && !mySubmissionsLoading">
          <b-col cols="12">
            <b-button v-b-toggle.collapse-my-subs variant="primary">Toggle All My Submissions</b-button>
          </b-col>
        </b-row>
        <b-collapse id="collapse-my-subs" class="mt-2">
          <b-row class="mt-2" v-if="!isSpecialist()">
            <b-card style="width:100%; background-color: #fdfdfc">
              <b-col>
                <h2 style="color: #36590D">My Submissions</h2>
                <ApprovalQueue slug="submissions-queue" :items="mySubmissions"
                               :isLoading="mySubmissionsLoading"/>
              </b-col>
            </b-card>
          </b-row>
        </b-collapse>

        <b-row class="mt-4" v-if="icsApprovals.length > 0">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">ICS Approvals</h2>
              <ApprovalQueue slug="ics-approvals-queue" :items="icsApprovals"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="isCfo()">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">CFO Reviews</h2>
              <ApprovalQueue slug="cfo-review-queue" :items="cfoReviews"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="isIcsHrm()">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">ICS Redeployment/Reassignment Requests</h2>
              <ApprovalQueue slug="ics-queue" :items="icsQueue"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="isLeave()">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">Leave Requests</h2>
              <LeaveQueue slug="leave-queue" :items="leaveQueue"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="$keycloak.authenticated && isAudit()">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">Audit Reviews</h2>
              <ApprovalQueue slug="audit-queue" :items="auditReviews"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="$keycloak.authenticated && isHRTransactions()">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">HR Transactions</h2>
              <b-nav-item-dropdown id="create_tx" text="Create Transaction" v-show="false">
                <b-dropdown-item href="/separation">Separation Payout</b-dropdown-item>
              </b-nav-item-dropdown>
              <ApprovalQueue slug="fhr-transactions-queue" :items="hrTransactions"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="$keycloak.authenticated && isSalary()">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">Salary Reviews</h2>
              <ApprovalQueue slug="salary-review-queue" :items="salaryReviews"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="$keycloak.authenticated && isDraft()">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">Draft Posting Reviews</h2>
              <ApprovalQueue slug="draft-positing-review-queue" :items="draftPostingReviews"/>
            </b-col>
          </b-card>
        </b-row>

        <b-row class="mt-4" v-if="drafts">
          <b-card style="width:100%; background-color: #fdfdfc">
            <b-col>
              <h2 style="color: #36590D">Your Draft Requests</h2>
              <b-table hover small responsive show-empty
                       id="draftQueue"
                       :fields="draftFields"
                       :items="drafts">
                <template v-slot:cell(requestType)="data">
                  {{ data.item.payload.requestTypeValue ? data.item.payload.requestTypeValue.description : 'Unknown' }}
                </template>
                <template v-slot:cell(actions)="row">
                  <b-button size="sm" @click="editDraft(row.item)" class="mr-1">
                    edit
                  </b-button>
                  <b-button size="sm" @click="deleteDraft(row.item)" class="mr-1">
                    delete
                  </b-button>
                </template>
                <template v-slot:empty="scope">
                  <p>No draft requests found.</p>
                </template>
              </b-table>
            </b-col>
          </b-card>
        </b-row>
      </div>
      <div v-if="!hasAnyRole()">
        <RequestRole/>
      </div>

    </b-container>

  </div>
</template>

<script>
import ApprovalQueue from '@/components/ApprovalQueue.vue'
import LeaveQueue from '@/components/LeaveQueue.vue'
import axios from "axios"
import pageTitle from '@/mixins/pageTitle'
import { roleService } from "@/mixins/roleService.js";
import RequestRole from "@/views/user-management/RequestRole";

export default {
  title () {
    return `${this.$keycloak.fullName}'s Work Queues`
  },
  components: {
    RequestRole,
    ApprovalQueue,
    LeaveQueue,
  },
  mixins: [
    pageTitle,
    roleService
  ],
  data: () => ({
    fmApprovals: [],
    myApprovals: [],
    myWorkQueue: [],
    myHiringManagerQueue: [],
    mySpecialistQueue: [],
    myWorkQueueLoading: true,
    mySubmissionsLoading: true,
    myPayrollQueue: [],
    payrollAssignedOnly: true,
    auditReviews: [],
    mySubmissions: [],
    icsApprovals: [],
    cfoReviews: [],
    icsQueue: [],
    leaveQueue: [],
    drafts: null,
    hrTransactions: [],
    salaryReviews: [],
    draftPostingReviews: [],
    draftFields: [
      {key: 'createDate', sortable: true, label: 'Last Updated'},
      {key: 'requestType', sortable: true, label: 'Request Type'},
      {key: 'actions', label: 'Actions'},
    ]
  }),

  created() {
  },

  computed: {
  },

  mounted() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.loadMyPendingApprovals()

      if (this.$keycloak &&
          (this.isSpecialist() ||
              this.isAdmin())) {
        this.loadMyWorkQueue()
      }

      if (this.$keycloak && (this.isPayroll() || this.isAdmin())) {
        this.loadPayrollQueue(this.payrollAssignedOnly)
      }

      if (this.$keycloak && this.isAudit()) {
        this.loadAuditReviews()
      }

      if (this.isFfm()) {
        this.loadFMPendingApprovals()
      }
      if (this.isSalary()) {
        this.loadSalaryReviews()
      }

      this.loadMySubmissions()
      this.loadICSApprovals()

      if (this.isCfo()) {
        this.loadCFOReviews()
      }

      if (this.isIcsHrm()) {
        this.loadICSQueue();
      }

      if (this.isLeave()) {
        this.loadLeaveQueue();
      }

      if (this.isHRTransactions()) {
        this.loadHRTransactions()
      }

      if (this.isDraft()) {
        this.loadDraftPostingQueue();
      }

      this.loadHiringManagerQueue();
      this.loadSpecialistQueue();
      this.loadDrafts()
    },

    loadDraftPostingQueue() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/draftPosting/queue`)
          .then(response => {
            this.draftPostingReviews = response.data
          })
    },

    loadFMPendingApprovals() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/fmReviews`)
          .then(response => {
            this.fmApprovals = response.data
          })
    },

    loadSalaryReviews() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/salaryReview/queue`)
          .then(response => {
            this.salaryReviews = response.data
          })
    },

    loadMyPendingApprovals() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/myApprovals`)
          .then(response => {
            this.myApprovals = response.data
          })
    },

    loadHRTransactions() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/transactions/queue`)
          .then(response => {
            this.hrTransactions = response.data
          })
    },

    loadMySubmissions() {
      this.mySubmissionsLoading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/myRequests`)
          .then(response => {
            this.mySubmissions = response.data
            this.mySubmissionsLoading = false
          })
    },

    loadMyWorkQueue() {
      this.myWorkQueueLoading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/myWorkQueue`)
          .then(response => {
            this.myWorkQueue = response.data
            this.myWorkQueueLoading = false
          })
    },

    loadHiringManagerQueue() {
      this.myWorkQueueLoading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/hiringManagerQueue`)
          .then(response => {
            this.myHiringManagerQueue = response.data
            this.myWorkQueueLoading = false
          })
    },

    loadSpecialistQueue() {
      this.myWorkQueueLoading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/specialistQueue`)
          .then(response => {
            this.mySpecialistQueue = response.data
            this.myWorkQueueLoading = false
          })
    },

    loadICSQueue() {
      this.myWorkQueueLoading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/icsWorkQueue`)
          .then(response => {
            this.icsQueue = response.data
            this.myWorkQueueLoading = false
          })
    },

    loadLeaveQueue() {
      this.myWorkQueueLoading = true
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/leaveWorkQueue`)
          .then(response => {
            this.leaveQueue = response.data
            this.myWorkQueueLoading = false
          })
    },

    loadPayrollQueue(assigned) {
      this.myWorkQueueLoading = true
      if (assigned) {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/payroll/queue`)
                .then(response => {
                  this.myPayrollQueue = response.data
                  this.myWorkQueueLoading = false
                })
      } else {
        axios.get(`${process.env.VUE_APP_API_BASE_URL}/payroll/queue/all`)
                .then(response => {
                  this.myPayrollQueue = response.data
                  this.myWorkQueueLoading = false
                })
      }
    },

    loadAuditReviews() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/auditReviews`)
          .then(response => {
            this.auditReviews = response.data
          })
    },
    loadICSApprovals() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/icsApprovals`)
          .then(response => {
            this.icsApprovals = response.data
          })
    },
    loadCFOReviews() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/request/cfoReviews`)
          .then(response => {
            this.cfoReviews = response.data
          })
    },

    loadDrafts() {
       axios.get(`${process.env.VUE_APP_API_BASE_URL}/drafts/user`)
          .then(response => {
            if (response.data) {
              this.drafts = response.data
            } else {
              this.drafts = []
            }
          })
    },

    editDraft(item) {
      this.$router.push({name: 'requestDraft', params: {draftId: item.id}})
    },

    deleteDraft(item) {
      this.$bvModal.msgBoxConfirm('Are you sure?')
          .then(value => {
            if (value) {
               axios.delete(`${process.env.VUE_APP_API_BASE_URL}/drafts/${item.id}`)
                .then(response => { 
                  this.loadDrafts()
                })
            }
            })
          .catch(err => {
            // An error occurred
          })
    }

  }
}
</script>

<style>
.card .queueCard: {
  width:100% !important; background-color: #fdfdfc !important;
}
</style>